
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pawnId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"deploymentId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"flows"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"as"},"value":{"kind":"EnumValue","value":"ANY"}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignmentProgress"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"AND"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"field"},"value":{"kind":"StringValue","value":"pawn.pawn.pawnId","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"int"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pawnId"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"field"},"value":{"kind":"StringValue","value":"deployment.deploymentId","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"int"},"value":{"kind":"Variable","name":{"kind":"Name","value":"deploymentId"}}}]}}]}]}}]}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"assignmentProgressId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"deployment"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deploymentId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"roleHandle"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"pawn"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"context"},"value":{"kind":"EnumValue","value":"GLOBAL"}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pawn"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pawnId"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"devTagsLists"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"PhysicalLayoutItem"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ClassroomRulesItem"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ClassroomRoutinesItem"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"SmoothTransitionsItem"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"AcademicObjectivesItem"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"PacingInstructionItem"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"StudentAccuracyItem"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"StudentEngagementItem"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"BehavioralExpectationsItem"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ActiveSupervisionItem"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"PraiseItem"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ReprimandsItem"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"RatioItem"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ReinforcementItem"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"NoncontingentAttentionItem"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"InteractionsItem"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"DisruptiveBehaviorItem"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ScheduleItem"},"arguments":[],"directives":[]}]}}]}}]}}]}}],"loc":{"start":0,"end":1301}};
    doc.loc.source = {"body":"query($pawnId: Int, $deploymentId: Int) {\n    flows(as: ANY) {\n        assignmentProgress(\n            filter: {\n                AND: [\n                    { eq: { field: \"pawn.pawn.pawnId\", int: $pawnId } }\n                    { eq: { field: \"deployment.deploymentId\", int: $deploymentId } }\n                ]\n            }\n        ) {\n            status\n            assignmentProgressId\n            deployment {\n                deploymentId\n                roleHandle\n            }\n            pawn(context: GLOBAL) {\n                pawn {\n                    pawnId\n                }\n            }\n            devTagsLists {\n                PhysicalLayoutItem\n                ClassroomRulesItem\n                ClassroomRoutinesItem\n                SmoothTransitionsItem\n                AcademicObjectivesItem\n                PacingInstructionItem\n                StudentAccuracyItem\n                StudentEngagementItem\n                BehavioralExpectationsItem\n                ActiveSupervisionItem\n                PraiseItem\n                ReprimandsItem\n                RatioItem\n                ReinforcementItem\n                NoncontingentAttentionItem\n                InteractionsItem\n                DisruptiveBehaviorItem\n                ScheduleItem\n            }\n        }\n    }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
